import { Navigate, createFileRoute } from "@tanstack/react-router";

import { useCurrentVenueQuery } from "../../../hooks/venues";

export const Route = createFileRoute("/gym/$venueUuid/routes/")({
  component: () => {
    const { data: venue } = useCurrentVenueQuery();
    if (venue && venue.climbTypes) {
      return (
        <Navigate
          to={`/gym/$venueUuid/routes/$climbType`}
          params={{ venueUuid: venue.uuid, climbType: venue.climbTypes[0] }}
          search={{ tab: "maps" }}
        />
      );
    }
    return null;
  },
});
